import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getClassName, getValue } from "../../../../components/Converter";
import ConvertUnit from "../../../../components/Math/Conversion/ConvertUnit";
import { ImperialUnits, MetricUnits } from "../../../../components/Math/Units/AllUnits";
import Kilopound from "../../../../components/Math/Units/Imperial/Kilopound";
import KiloNewton from "../../../../components/Math/Units/Metric/KiloNewton";
import AlertBox from "../../../../components/Messages";
import { NumberFormatText } from "../../../../components/NumberFormatText";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { MAX_BEMESSUNGSLAST } from "../../../../constants";
import { decimalSeparator, thousandSeparator } from "../../../../i18n";
import { selectTotalDesignLoad, setTotalDesignLoad } from "../../../../store/slices/fhwaSlice";
import { selectIsImperial, selectIsMetric } from "../../../../store/slices/settingsSlice";

function DesignLoad({ readOnly }) {
  const dispatch = useDispatch();
  const { t } = useTranslation(["translation", "fhwa"]);

  const designLoad = useSelector(selectTotalDesignLoad);

  const isImperial = useSelector(selectIsImperial);
  const isMetric = useSelector(selectIsMetric);

  let unitType = isMetric ? MetricUnits.KiloNewton : isImperial ? ImperialUnits.Kilopound : null;

  const metricUnit = <KiloNewton />;
  const imperialUnit = <Kilopound />;

  function isWritable() {
    return (
      <NumberFormat
        decimalScale={4}
        className={getClassName(designLoad.current)}
        value={getValue(designLoad.current)}
        decimalSeparator={decimalSeparator()}
        thousandSeparator={thousandSeparator()}
        displayType="input"
        type="text"
        allowNegative={true}
        onValueChange={(value) => {
          dispatch(
            setTotalDesignLoad({
              value: value.floatValue === undefined ? Number.NaN : value.floatValue,
              unit: unitType,
            })
          );
        }}
      />
    );
  }

  function isStatic() {
    return (
      <span className="input">
        {/* INFO: Wunsch Aziz decimalScale={2} */}
        <NumberFormatText value={designLoad.current} decimalScale={2} />
      </span>
    );
  }

  return (
    <>
      <RowBody
        titleValue={<p>{t("designLoad", { ns: "fhwa" })}</p>}
        indicesValue={
          <span>
            P<sub>d</sub>
          </span>
        }
        inputValue={readOnly ? isStatic() : isWritable()}
        unitValue={<ConvertUnit Metric={metricUnit} Imperial={imperialUnit} />}
      />
      <Col md={8}>
        {isMetric && (
          <AlertBox
            show={designLoad.metric >= MAX_BEMESSUNGSLAST}
            message={t("inner.fdCalculation.errorText.designloadToBig", {
              value: MAX_BEMESSUNGSLAST,
            })}
          />
        )}

        {isImperial && (
          <AlertBox
            show={designLoad.imperial >= 497}
            message={t("inner.fdCalculation.errorText.designloadToBig", {
              value: 497,
            })}
          />
        )}
      </Col>
    </>
  );
}

export default DesignLoad;
